module.exports = __webpack_public_path__ + "static/media/pandas.24a9a779.svg";